var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    fillRule: "evenodd",
    d: "M7.67 2h8.67C19.73 2 22 4.38 22 7.92v8.17c0 3.53-2.27 5.91-5.66 5.91H7.67C4.28 22 2 19.62 2 16.09V7.92C2 4.38 4.28 2 7.67 2m7.91 13.81c.25 0 .5-.13.64-.37a.744.744 0 0 0-.26-1.03l-3.56-2.12V7.67a.75.75 0 1 0-1.5 0v5.05c0 .26.14.51.37.64l3.92 2.34c.12.08.26.11.39.11",
    clipRule: "evenodd"
  })));
};
export default SvgClock;